





























import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import {VersionTaskState} from '@/tasks/types/VersionTaskState';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'TorontoCHMB41HQuiz3Question1',
  mixins: [DynamicQuestionMixin()],
  props: {
    taskState: {
      type: Object as PropType<VersionTaskState>,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        value: null as null | string,
      },
      imagePrefix: prefixPublicAsset('/img/assignments/UofT/CHMB41H/quiz-3/question-1/q3q1'),
    };
  },
  computed: {
    seed(): number {
      return this.$inertia.getSeed();
    },
    version(): number {
      return this.taskState.getValueByName('version')?.content?.value ?? 1;
    },
    choices(): string[] {
      return seededShuffle(['A', 'B', 'C', 'D'], this.seed);
    },
    image(): string {
      return this.imagePrefix + `v${this.version}.png`;
    },
    images(): string[] {
      return this.choices.map((l: string) => this.imagePrefix + '-choice' + l + '.png');
    },
  },
});
